import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryPurchaseOrderListResponse } from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setPurchaseOrderList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useInventoryPurchaseOrderSearchAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (po_id: string = "") => {
      dispatch(
        setLoading({
          key: "isInventoryPurchaseOrderListLoadingInProgess",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${INVENTORY_MODULE?.PURCHASE_ORDER_LIST?.baseURL}?po_number=${po_id}`,
            {},
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IInventoryPurchaseOrderListResponse>) => {
            if (res.data.status === true) {
              dispatch(setPurchaseOrderList({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isInventoryPurchaseOrderListLoadingInProgess",
                  status: false,
                }),
              );
              return { status: true, message: "batch" };
            } else {
              dispatch(setPurchaseOrderList({ data: [] }));
              dispatch(
                setLoading({
                  key: "isInventoryPurchaseOrderListLoadingInProgess",
                  status: false,
                }),
              );
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isInventoryPurchaseOrderListLoadingInProgess",
                status: false,
              }),
            );
            dispatch(setPurchaseOrderList({ data: [] }));
            captureError(e)
            return { status: false, message: "batch_not_created" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
